import { breakpoint } from '@sketch/global-styles'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 40px;
  grid-template-columns: repeat(1, 1fr);
  align-items: flex-start;

  ${breakpoint('xs')`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${breakpoint('sm')`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${breakpoint('md')`
    grid-template-columns: repeat(4, 1fr);
  `}
`
